const resources = {
  "en": {
    "forecastAiHistory": {
      "title": "Forecast assistant history",
      "description": "Review previous questions and answers generated by the forecast AI assistant.",
      "historyTitle": "Saved questions",
      "historyDescription": "{{count}} saved questions are currently available in this history.",
      "historyCaption": "Open any saved question to review the full answer or continue the conversation.",
      "loadError": "Failed to load forecast assistant history.",
      "deleteSuccess": "Entry removed from history.",
      "deleteError": "Failed to delete history entry.",
      "list": {
        "empty": "No history yet",
        "deleteConfirm": "Delete this entry?",
        "deleteAction": "Delete",
        "openDetails": "Open details",
        "questionLabel": "Question",
        "answerLabel": "Answer",
        "fallback": "—",
        "processing": "Processing…"
      },
      "detail": {
        "title": "Forecast assistant response",
        "description": "Review the saved forecast answer, then continue the conversation from the same history entry.",
        "summaryTitle": "Saved entry",
        "summaryDescription": "This section keeps the original prompt, answer, and basic request metadata together before you continue the chat.",
        "contextLabel": "Context",
        "contextToggle": "Show details",
        "back": "Back",
        "createdAt": "Created",
        "anchorDay": "Anchor day",
        "months": "Months",
        "language": "Language",
        "questionLabel": "Question",
        "answerLabel": "Answer",
        "loadError": "Unable to load this forecast assistant entry.",
        "processing": "Processing…",
        "failed": "Unable to generate a response.",
        "chatTitle": "Conversation",
        "chatDescription": "Ask follow-up questions on the same forecast context, export the transcript, or copy individual assistant replies.",
        "chatPlaceholder": "Ask a follow-up question…",
        "chatSend": "Send",
        "chatSending": "Sending…",
        "chatEmpty": "No chat messages yet.",
        "chatError": "Failed to send the message.",
        "providerUnavailableInline": "AI provider is temporarily unavailable. We'll retry shortly.",
        "chatLoadError": "Unable to load the chat history.",
        "chatCredits": "{{count}} credits left",
        "chatCreditsUnknown": "Credits unavailable",
        "chatCreditsEmpty": "No AI credits left.",
        "chatTyping": "Typing…",
        "chatCopy": "Copy answer",
        "chatCopySuccess": "Answer copied.",
        "chatCopyError": "Unable to copy the answer.",
        "export": {
          "copy": "Copy chat",
          "download": "Download .txt",
          "copySuccess": "Chat copied to clipboard.",
          "copyError": "Unable to copy the chat.",
          "downloadError": "Unable to download the chat.",
          "copyHint": "Paste into ChatGPT or notes.",
          "downloadHint": "Save a plain text file.",
          "scrollToLatest": "Jump to latest message",
          "contextLabel": "Context",
          "userLabel": "You",
          "assistantLabel": "AI"
        }
      }
    }
  },
  "uk": {
    "forecastAiHistory": {
      "title": "Історія асистента прогнозів",
      "description": "Переглядайте попередні запитання та відповіді, згенеровані асистентом прогнозів.",
      "historyTitle": "Збережені запитання",
      "historyDescription": "У цій історії зараз доступно {{count}} збережених запитань.",
      "historyCaption": "Відкрийте будь-яке збережене запитання, щоб переглянути повну відповідь або продовжити розмову.",
      "loadError": "Не вдалося завантажити історію асистента прогнозів.",
      "deleteSuccess": "Запис видалено з історії.",
      "deleteError": "Не вдалося видалити запис історії.",
      "list": {
        "empty": "Історії поки немає",
        "deleteConfirm": "Видалити цей запис?",
        "deleteAction": "Видалити",
        "openDetails": "Відкрити деталі",
        "questionLabel": "Запитання",
        "answerLabel": "Відповідь",
        "fallback": "—",
        "processing": "Формується відповідь…"
      },
      "detail": {
        "title": "Відповідь асистента прогнозів",
        "description": "Перегляньте збережену відповідь прогнозного асистента, а потім продовжуйте розмову з цього самого запису історії.",
        "summaryTitle": "Збережений запис",
        "summaryDescription": "Тут разом зібрані початковий запит, відповідь і базові метадані запиту, перш ніж ви продовжите чат.",
        "contextLabel": "Контекст",
        "contextToggle": "Показати деталі",
        "back": "Назад",
        "createdAt": "Створено",
        "anchorDay": "Опорний день",
        "months": "Місяці",
        "language": "Мова",
        "questionLabel": "Запитання",
        "answerLabel": "Відповідь",
        "loadError": "Не вдалося завантажити цей запис асистента прогнозів.",
        "processing": "Формується відповідь…",
        "failed": "Не вдалося сформувати відповідь.",
        "chatTitle": "Розмова",
        "chatDescription": "Ставте уточнювальні запитання в тому самому прогнозному контексті, експортуйте розмову або копіюйте окремі відповіді асистента.",
        "chatPlaceholder": "Поставте уточнювальне запитання…",
        "chatSend": "Надіслати",
        "chatSending": "Надсилання…",
        "chatEmpty": "Повідомлень чату ще немає.",
        "chatError": "Не вдалося надіслати повідомлення.",
        "providerUnavailableInline": "AI-провайдер тимчасово недоступний. Незабаром спробуємо знову.",
        "chatLoadError": "Не вдалося завантажити історію чату.",
        "chatCredits": "Залишилось кредитів: {{count}}",
        "chatCreditsUnknown": "Кредити недоступні",
        "chatCreditsEmpty": "AI-кредитів немає.",
        "chatTyping": "Друкує…",
        "chatCopy": "Скопіювати відповідь",
        "chatCopySuccess": "Відповідь скопійовано.",
        "chatCopyError": "Не вдалося скопіювати відповідь.",
        "export": {
          "copy": "Скопіювати чат",
          "download": "Завантажити .txt",
          "copySuccess": "Чат скопійовано.",
          "copyError": "Не вдалося скопіювати чат.",
          "downloadError": "Не вдалося завантажити чат.",
          "copyHint": "Вставте у ChatGPT або нотатки.",
          "downloadHint": "Збережіть текстовий файл.",
          "scrollToLatest": "Перейти до останнього",
          "contextLabel": "Контекст",
          "userLabel": "Ви",
          "assistantLabel": "AI"
        }
      }
    }
  }
};

export default resources;
